import { render, staticRenderFns } from "./FinishDetail.vue?vue&type=template&id=4cdf9e2a"
import script from "./FinishDetail.vue?vue&type=script&lang=js"
export * from "./FinishDetail.vue?vue&type=script&lang=js"
import style0 from "./FinishDetail.vue?vue&type=style&index=0&id=4cdf9e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports